import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=c12c8e1e&scoped=true&lang=pug&"
import script from "./UserList.vue?vue&type=script&lang=ts&"
export * from "./UserList.vue?vue&type=script&lang=ts&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=c12c8e1e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12c8e1e",
  null
  
)

export default component.exports